import {MessageIntl} from "../TranslateHelpers";

export const messagesIntl:MessageIntl = {
  fr: {
    url_login: "/login",
    url_create_account: "/creer-compte",
    url_forgot_mdp: "/mot-de-passe-oublie",
    url_reset_mdp: "/reset-mot-de-passe",
    url_profile: "/profil",
    url_catalogue: "produits",
    url_cart: "/panier",
    url_detail_product: "/produit",
    url_request_offer: "/demander-offre",
    url_search: "/search/node",

    email: "Email",
    password: "Mot de passe",
    forgotten_password: "Mot de passe oublié ?",
    login: "Se connecter",
    logout: "Se déconnecter",
    no_account_yet: "Pas encore de compte ?",
    create_account : "Créer un compte",
    welcome_back: "Heureux de vous revoir !",
    connect_to_account: "Connectez-vous à votre compte pour bénéficier des avantages.",
    have_account: "Vous avez un compte ?",
    login_avantages: "Connectez-vous pour bénéficier de tous les avantages.",
    profile: "Profil",
    cart: "Panier",
    register: "S'inscrire",
    authentifie: "Vous êtes authentifié",
    forgot_password: "Vous avez oublié votre mot de passe ?",
    change_password: "Changer mon mot de passe",
    enter_new_password: "Entrez un nouveau mot de passe",
    description_new_password: "Pas de souci ! Entrez votre e-mail et procédez au changement de votre mot de passe.",
    ask_new_password: "Demandez un nouveau mot de passe",
    reset_password_success: "Votre mot de passe a été changé avec succès!",
    password_found: "Mot de passe retrouvé ?",
    confirm_password: "Confirmer le mot de passe",
    you_may_also_like: "Vous aimerez aussi",
    creating_account: "Création d'un compte",
    creating_personal_account: "Création d'un compte personnel",
    creating_company_account: "Création d'un compte société",
    account_type: "Type de compte",
    infos: "Informations",
    summary: "Résumé",
    personal_account: "Compte personnel",
    company_account: "Compte société",
    confirmation:"Confirmation",
    next: "Suivant",
    personal_info: "Informations personnelles",
    name: "Nom",
    firstname: "Prénom",
    birthdate: "Date de naissance",
    birthplace: "Lieu de naissance",
    national_registration_num: "N° de registre national",
    confirme_continue: "Confirmer et continuer",
    continue: "Continuer",
    confirme: "Confirmer",
    previous : "Précédent",
    company: "Société",
    address: "Adresse",
    num_tva: "N° TVA/N° entreprise",
    street: "Rue",
    zip: "Code postal",
    num_com_paritaire: "N° de commission paritaire",
    city: "Ville",
    phone: "Téléphone",
    department: "Département",
    company_name: "Nom de la société",
    country: "Pays",
    mobile_phone : "GSM",
    function: "Fonction",
    back_to_previous_step: "Revenir à l'étape précédente",
    fill_form: "Remplissez le formulaire ci-dessous",
    represented_by: "Représenté par",
    fields_required: "Ce champ est obligatoire",
    warning_required_fields: "Attention, champs obligatoires. Veuillez les remplir.",
    company_info: "Informations de la société",
    address_company: "Adresse de la société",
    fax: "Fax",
    conditions_pwd: "8-32 caractères, au moins une lettre minuscule, une lettre majuscule et un chiffre",
    conditions_email: "Format d'e-mail invalide.",
    register_to_newsletter: "S'inscrire à la newsletter",
    password_no_match: "Les mots de passe doivent être identiques",
    you_have_account: "Vous avez déjà un compte",
    view_profile: "Voir mon profil",
    profile_created_successfully: "Votre compte a été créé avec succès !",
    error_created_profile : "Une erreur s'est produite lors de la création du compte.",
    profile_created_confirmation_email: "Vous recevrez un mail pour confirmer votre adresse mail.",
    view_article: "Voir l'article",
    wishlist: "Mes produits favoris",
    my_orders: "Mes commandes",
    my_profile: "Mon profil",
    my_addresses: "Mes adresses",
    add_address: "Ajouter une adresse",
    save: "Enregistrer",
    order_summary: "Résumé de la commande",
    products: "Produit(s)",
    cahnge: "Changer",
    delete: "Supprimer",
    add_new_address: "Ajouter une nouvelle adresse",
    change_password_here: "Vous pouvez changer votre mot de passe en cliquant ici",
    equipment_securite_bien_etre :"Équipements sécurité / bien-être",
    view_categories: "Voir toutes les catégories",
    apply_filters: "Appliquer les filtres",
    delete_filters: "Supprimer tous les filtres",
    email_sent: "Un email vous a été envoyé à l'adresse mail :",
    invalid_address: "Entrez une adresse valide",
    connect_for_page: "Vous devez être connecté pour voir cette page. Si vous n'avez pas de compte, vous pouvez en créer un.",
    i_accept_condition:" J'accepte les conditions générales",
    read_general_conditions: "Lire les conditions générales",
    accept_condition: "Veuillez accepter les conditions générales",
    error: "Erreur",
    register_newsletter_success: "Vous êtes bien inscrit à la newsletter",
    message: "Message",
    send: "Envoyer",
    contact_form_submitted_success: "Votre message a été envoyé avec succès. Nous vous répondrons dans les plus brefs délais",
    dont_miss_thing:"Ne manquez rien!",
    register_to_our_newsletter:"Inscrivez-vous à notre newsletter",
    your_cart: "Votre panier",
    yes: "Oui",
    no: "Non",
    add_service_to_order: "Désirez-vous ajouter un service à votre commande ?",
    select_service: "Sélectionnez un service",
    add_remark: "Ajouter une remarque",
    submit_request: "Soumettre la demande",
    add_to_cart: "Ajouter au panier",
    delete_from_cart: "Retirer du panier",
    view_product: "Voir le produit",
    add_to_favourites: "Ajouter aux favoris",
    delete_from_favourites: "Retirer des favoris",
    details: "Détails",
    specificites: "Spécificités",
    documents: "Documents",
    services: "Services",
    summary_cart: "Résumé du panier",
    total: "Total",
    reduction: "Réduction",
    subtotal: "Sous-total",
    request_offer: "Demander une offre",
    request_an_offer: "Demande d'offre",
    show: "Afficher",
    product_added: "Un produit ajouté",
    request_offer_for_products: "Demande d'offre pour les articles suivants",
    intro_text_request_offer: "Pour traiter au mieux votre demande, veuillez remplir le formulaire ci-dessous afin qu'ESM puisse prendre contact avec vous",
    delete_product: "Retirer cet article",
    your_request_offer: "Votre demande d'offre",
    go_next_step: "Passer à l'étape suivante",
    select_product_before_offer: "Sélectionner d'autres produits avant de faire ma demande d'offre",
    make_request: "Faire ma demande d'offre",
    make_products_request: "Faire ma demande d'offre pour les produits sélectionnés",
    ask: "Demander",
    no_product_yet: "Vous n'avez pas encore de produit dans votre demande d'offre",
    request_send: "Votre demande d'offre à bien été envoyée",
    order_number: "N° de commande",
    date: "Date",
    article: "Article",
    reference: "Référence",
    price: "Prix",
    account_updated_successfully: "Votre compte a été modifié avec succès !",
    products_found: "produits trouvés",
    product_found: "produit trouvé",
    my_offer_request: "Ma demande d'offre",
    select_option: "Sélectionnez une option",
    make_guest_order: "Faire une demande d'offre en tant qu'invité",
    ordered_successfully: "Votre demande a été prise en compte avec succès !",
    order_email_send: "Vous allez recevoir un email récapitulatif de votre demande.",
    catalogue: "Catalogue",
    see_catalog: "Voir le catalogue",
    back_to_selection: "Retour à ma sélection",
    sub_total: "Sous-total",
    tax_total: "TVA",
    htva: "HTVA",
    brand: "Marque",
    quantity: "Quantité",
    shoeSize: "Pointure",
    grammage: "Grammage",
    size: "Taille",
    length: "Longueur",
    capacity: "Capacité",
    color: "Couleur",
    home: "Accueil",
    variant_not_available: "Nous sommes désolés, mais ce produit avec ces options ne sont pas/plus disponibles.",
    reorder: "Re-commander",
    no_product_in_cart: "Vous n'avez pas d'article dans votre panier",
    will_be_redirected: "Vous allez être redirigé",
    session_expired: "Votre session a expiré, veuillez vous reconnecter",
    example_mail: "adresse@adresse.com",
    all_filters: "Tous les filtres",
    mots_cles: "Mots-clés",
    resultats: "Résultats",
    no_result: "Pas de résultat",
    search_for: "Recherche pour",
    search: "Recherche",
    content_found_on_website: "contenu trouvé sur le site",
    contents_found_on_website: "contenus trouvés sur le site",
    found_results: "Nous avons trouvé {nbResult} résultats",
    found_result: "Nous avons trouvé {nbResult} résultat",
    view_content: "Voir le contenu",
    no_product: "Pas de produit trouvé",
    no_product_in_stock: "Pas de produit en stock trouvé",
    number_of_product: "Nombre de produit(s)",
    view_order: "Voir la commande",
    back_to_order_list: "Retour à la liste de commande",
    action: "Action",
    order_date: "Commande n° {orderNumber} passée le {date}",
    looking_for_product: "A la recherche de matériel ?",
    looking_for_text: "Vous cherchez du matériel correspondant à votre activité, à vos besoins professionnels, personnels, ...",
    unit_sale: "Ce produit est vendu par",
    indicatif_price: "Ce prix est à titre indicatif",
    see_pricing: "Vous souhaitez voir nos tarifs et passer commande ?",
    connect_or_create: "<a href='/fr/login'>Connectez-vous</a> <br>ou <br><a href='/fr/creer-compte'>créez un compte</a> <br>gratuitement et en quelques secondes !",
    send_request_offer: "Envoyer la demande d'offre",
    catalog_end_of_stock: "Voir le catalogue fin de stock",
    end_of_stock: "fin de stock",
    postcode: "Code postal",
    select_billing_address: "Sélectionnez une adresse de facturation/livraison",
    edit_addresses_profile: "Vous pouvez modifier vos adresses dans votre profil",
    submit_order_in_progress: "Soumission de la commande en cours",
    main_address: "Adresse principale",
  },
  nl: {
    url_login: "/login",
    url_create_account: "/account-aanmaken",
    url_forgot_mdp: "/watchwoord-vergeten",
    url_reset_mdp: "/reset-watchwoord",
    url_profile: "/profiel",
    url_catalogue: "producten",
    url_cart: "/mandje",
    url_detail_product: "/product",
    url_request_offer: "/verzoek-voorstel",
    url_search: "/search/node",

    email: "E-mail",
    password: "Wachtwoord",
    forgotten_password: "Wachtwoord vergeten?",
    login: "Login",
    logout: "Logout",
    no_account_yet: "Nog geen account?",
    create_account : "Maak een account aan",
    welcome_back: "Goed om je weer te zien!",
    connect_to_account: "Log in op uw account om van de voordelen te genieten.",
    have_account: "Heb je een rekening?",
    profile: "Profiel",
    cart: "Mandje",
    register: "Aanmelden",
    authentifie: "U bent geverifieerd",
    login_avantages: "Connectez-vous pour bénéficier de tous les avantages.",
    forgot_password: "Wachtwoord vergeten?",
    change_password: "Wijzig mijn wachtwoord",
    enter_new_password: "Voer een nieuw wachtwoord in",
    description_new_password: "Geen probleem. Voer uw e-mailadres in en ga verder om uw wachtwoord te wijzigen.",
    ask_new_password: "Een nieuw wachtwoord aanvragen",
    reset_password_success: "Uw wachtwoord is succesvol gewijzigd!",
    password_found: "Wachtwoord opgehaald?",
    confirm_password: "Bevestig wachtwoord",
    you_may_also_like: "U zult ook graag",
    you_have_account: "U heeft al een account",
    view_profile: "Bekijk mijn profiel",
    profile_created_successfully: "Je account is succesvol aangemaakt !",
    error_created_profile : "Er is een fout opgetreden bij het aanmaken van het account.",
    profile_created_confirmation_email: "U ontvangt een e-mail om uw e-mailadres te bevestigen.",
    view_article: "Lees het artikel",
    wishlist: "Mijn favoriete producten",
    my_orders: "Mijn bestellingen",
    my_profile: "Mijn profiel",
    my_addresses: "Mijn adressen",
    save: "Registreren",
    delete: "Verwijderen",
    add_new_address: "Een nieuw adres toevoegen",
    order_summary: "Overzicht van de bestelling",
    postcode: "Postcode",
    products: "Producten",
    select_billing_address: "Selecteer een factuuradres",
    edit_addresses_profile: "Je kunt je adressen wijzigen in je profiel",
    cahnge: "Verander",
    change_password_here: "U kunt uw wachtwoord wijzigen door hier te klikken",
    equipment_securite_bien_etre :"Veiligheids-/welzijnsuitrusting",
    view_categories: "Bekijk alle categorieën",
    apply_filters: "Filters toepassen",
    delete_filters: "Alle filters verwijderen",
    email_sent: "Er is een e-mail gestuurd naar het volgende adres:",
    invalid_address: "Voer een geldig adres in",
    connect_for_page: "U moet ingelogd zijn om deze pagina te bekijken. Als u nog geen account hebt, kunt u er een aanmaken.",
    i_accept_condition:"Ik aanvaard de algemene voorwaarden",
    read_general_conditions: "Lees de algemene voorwaarden",
    accept_condition: "Gelieve de algemene voorwaarden te aanvaarden",
    register_newsletter_successfully: "U heeft zich ingeschreven voor de nieuwsbrief",
    error: "Fout",
    register_newsletter_success: "U heeft zich ingeschreven voor de nieuwsbrief",
    message: "Bericht",
    send: "Stuur",
    creating_account: "Een account aanmaken",
    creating_personal_account: "Een persoonlijk account aanmaken",
    creating_company_account: "Een bedrijfsaccount aanmaken",
    account_type: "Type account",
    infos: "Informatie",
    summary: "Samenvatting",
    personal_account: "Persoonlijke rekening",
    company_account: "Bedrijfsrekening",
    confirmation:"Bevestiging",
    next: "Volgende",
    personal_info: "Persoonlijke gegevens",
    name: "Naam",
    firstname: "Voornaam",
    birthdate: "Geboortedatum",
    birthplace: "Geboorteplaats",
    national_registration_num: "Nationaal registernummer",
    confirme_continue: "Bevestigen en doorgaan",
    continue: "Doorgaan",
    confirme: "Bevestig",
    previous : "Vorige",
    company: "Bedrijf",
    address: "Adres",
    num_tva: "BTW nr. / Ondernemingsnr.",
    street: "Straat",
    zip: "Postcode",
    num_com_paritaire: "Paritair Comité nr.",
    city: "Stad",
    phone: "Telefoon",
    fax: "Fax",
    department: "Afdeling",
    country: "Land",
    mobile_phone : "GSM",
    function: "Functie",
    back_to_previous_step: "Terug naar de vorige stap",
    fill_form: "Vul het onderstaande formulier in",
    represented_by: "Vertegenwoordigd door",
    fields_required: "Dit veld is verplicht",
    warning_required_fields: "* Aandacht, verplichte velden. Vul in of corrigeer.",
    restez_informe:"Blijf op de hoogte!",
    nom_prenom: "Naam/Voornaam",
    register_to_newsletter: "Inschrijven voor de nieuwsbrief",
    entrer_mail_mdp_oublie: "Voer een e-mailadres in om een e-mail te ontvangen met instructies om uw wachtwoord te wijzigen",
    entrer_mdp_confirmation: "Kies een nieuw wachtwoord",
    envoyer_mdp: "Stuur een e-mail om mijn wachtwoord te wijzigen",
    gestion_profil: "Beheer profiel",
    donnees_perso: "Persoonlijke gegevens",
    adresse_facturation: "Factuuradressen",
    contact_form_submitted_success: "Uw bericht is succesvol verzonden. Wij zullen zo spoedig mogelijk antwoorden",
    dont_miss_thing:"Mis niets!",
    register_to_our_newsletter: "Abonneer u op onze nieuwsbrief",
    your_cart: "Uw mandje",
    yes: "Ja",
    no: "Nee",
    add_service_to_order: "Wilt u een service aan uw bestelling toevoegen?",
    select_service: "Kies een dienst",
    add_remark: "Een commentaar toevoegen",
    submit_request: "Dien de aanvraag in",
    company_info: "Informatie over het bedrijf",
    company_name: "Bedrijfsnaam",
    address_company: "Adres van het bedrijf",
    add_to_cart: "In winkelmandje",
    delete_from_cart: "Verwijder uit mand",
    view_product: "Bekijk het product",
    add_to_favourites: "Toevoegen aan favorieten",
    delete_from_favourites: "Favorieten verwijderen",
    summary_cart: "Samenvatting van het mandje",
    total: "Totaal",
    reduction: "Reductie",
    subtotal: "Subtotaal",
    request_offer: "Een offerte aanvragen",
    request_an_offer: "Vraag naar aanbod",
    show: "Bekijk",
    product_added: "Een extra product",
    request_offer_for_products: "Verzoek om inschrijving voor de volgende artikelen",
    intro_text_request_offer: "Om uw verzoek zo goed mogelijk te kunnen behandelen, verzoeken wij u onderstaand formulier in te vullen zodat ESM contact met u kan opnemen",
    delete_product: "Verwijder dit item",
    your_request_offer: "Uw verzoek om een offerte",
    go_next_step: "Ga naar de volgende stap",
    no_product_yet: "U heeft nog geen product in uw aanvraag voor een voorstel",
    request_send: "Uw aanvraag voor een offerte is verzonden",
    select_product_before_offer: "Selecteer andere producten voordat ik een offerte aanvraag",
    make_request: "Doe mijn offerte aanvraag",
    make_products_request: "Vraag een offerte aan voor de geselecteerde producten",
    ask: "Vragen",
    order_number: "Bestellingsnummer",
    date: "Datum",
    article: "Artikel",
    reference: "Referentie",
    price: "Prijs",
    account_updated_successfully: "Uw account is succesvol gewijzigd!",
    products_found: "producten gevonden",
    product_found: "product gevonden",
    my_offer_request: "Mijn offerte aanvraag",
    select_option: "Kies een optie",
    make_guest_order: "Vraag een offerte aan als gast",
    ordered_successfully: "Uw aanvraag is succesvol in behandeling genomen!",
    order_email_send: "U ontvangt een e-mail met een samenvatting van uw aanvraag.",
    catalogue: "Catalogus",
    see_catalog: "Bekijk de catalogus",
    back_to_selection: "Terug naar mijn selectie",
    sub_total: "Subtotaal",
    tax_total: "BTW",
    htva: "excl. BTW",
    brand: "Merk",
    quantity: "Aantal",
    details: "Details",
    specificites: "Specificiteiten",
    documents: "Documenten",
    services: "Diensten",
    shoeSize: "Schoenmaat",
    grammage: "Grammage",
    size: "Maat",
    length: "Lengte",
    capacity: "Capaciteit",
    color: "Kleur",
    home: "Home",
    reorder: "Nabestellen",
    variant_not_available: "Het spijt ons, maar dit product met deze opties zijn niet/niet langer beschikbaar.",
    no_product_in_cart: "U heeft geen artikelen in uw mandje",
    will_be_redirected: "U wordt doorgestuurd",
    session_expired: "Uw sessie is verlopen, log opnieuw in",
    example_mail: "adres@adres.com",
    all_filters: "Alle filters",
    mots_cles: "Trefwoorden",
    resultats: "Resultaten",
    no_result: "Geen resultaat",
    search_for: "Onderzoek voor",
    search: "Onderzoek",
    content_found_on_website: "inhoud van de site",
    contents_found_on_website: "inhoud van de site",
    found_results: "We vonden {nbResult} resultaten",
    found_result: "We vonden {nbResult} resultaat",
    view_content: "Zie de inhoud",
    no_product: "Geen product gevonden",
    no_product_in_stock: "Geen product op voorraad gevonden",
    number_of_product: "Aantal product(en)",
    view_order: "Bestelling bekijken",
    back_to_order_list: "Terug naar bestellijst",
    action:"Acties",
    looking_for_product: "Op zoek naar materiaal?",
    looking_for_text: "Bent u op zoek naar apparatuur voor uw bedrijf, uw professionele of persoonlijke behoeften, enz.",
    unit_sale: "Dit product wordt verkocht in verpakkingen van ",
    indicatif_price: "Deze prijs is alleen ter informatie",
    see_pricing: "Wil je onze prijzen zien en een bestelling plaatsen?",
    connect_or_create: "<a href='/nl/login'>Log in</a> of <a href='/nl/account-aanmaken'>maak een gratis account aan</a> in slechts enkele seconden!",
    send_request_offer: "Verzend de offerteaanvraag",
    catalog_end_of_stock: "Bekijk de catalogus einde voorraad",
    end_of_stock : "einde voorraad",
    submit_order_in_progress: "Huidige bestelling verzenden",
    main_address: "Hoofdadres",
  }
};
